export default __webpack_public_path__ + "static/media/landscape9.d58280f2.jpg";